"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Comment = _interopRequireDefault(require("composer-lib/data/model/Comment"));

var _Conversation = _interopRequireDefault(require("composer-lib/data/model/Conversation"));

var _Conversations = _interopRequireDefault(require("composer-lib/data/model/Conversations"));

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

var _uniqueId = _interopRequireDefault(require("transmute/uniqueId"));

// Return new conversations block map with conversation added to it
function addConversationToBlockMap(state, conversation) {
  var correlationId = conversation.correlationId,
      id = conversation.id;
  var blockMap = state.blockMap,
      dummyConversations = state.dummyConversations; // Don't add if we already have this conversation or there's an
  // associated dummy conversation in the blockmap

  if (blockMap.hasIn([correlationId, id]) || (0, _conversationsHelpers.getDummyConversationId)(dummyConversations, id)) {
    return blockMap;
  }

  return blockMap.setIn([correlationId, id], conversation);
} // Return new conversations block map with comment added to it
// optional param `shouldAddUpdates` counts updates if passed as true


function addCommentToBlockMap(state, comment) {
  var shouldAddUpdates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var conversationId = comment.conversationId,
      correlationId = comment.correlationId,
      id = comment.id;
  var blockMap = state.blockMap,
      dummyConversations = state.dummyConversations;
  var dummyId = (0, _conversationsHelpers.getDummyConversationId)(dummyConversations, conversationId);
  var conversationIdInState = conversationId; // Want to add comment to the linked dummy conversation if we have one

  if (dummyId !== null) {
    conversationIdInState = dummyId;
  }

  var updates = blockMap.getIn([correlationId, conversationIdInState, 'updates']);
  var modifiedBlockMap = blockMap.updateIn([correlationId, conversationIdInState, 'comments'], new _immutable.List(), function (current) {
    if (!current.find(function (c) {
      return c.get('id') === id;
    })) {
      updates += 1;
      return current.push(comment);
    }

    updates -= 1;
    return current;
  }).updateIn([correlationId, conversationIdInState], function (current) {
    return current.set('isEmptyDummy', false);
  });

  if (shouldAddUpdates) {
    return modifiedBlockMap.setIn([correlationId, conversationIdInState, 'updates'], updates < 0 ? 0 : updates);
  }

  return modifiedBlockMap;
} // Return new conversations block map with 'has new data' (notifications/updates) removed
// from conversation with the given id


function clearUpdatedFromConversationInBlockMap(blockMap, openConversationId) {
  var clearedBlockMap = blockMap;
  blockMap.forEach(function (block, blockKey) {
    if (block.has(openConversationId)) {
      clearedBlockMap = blockMap.setIn([blockKey, openConversationId, 'updates'], 0);
    }
  });
  return clearedBlockMap;
} // Return new conversations block map with conversation of given correlationId and id
// removed from it. Removes entire block entry if it was only conversation in block


function deleteConversationInBlockMap(blockMap, correlationId, id) {
  var updatedBlockMap = blockMap.deleteIn([correlationId, id]);

  if (updatedBlockMap.get(correlationId).size > 0) {
    return updatedBlockMap;
  }

  return updatedBlockMap.delete(correlationId);
} // Remove conversation from all state objects that track the conversation's
// UI (eg. open conversations, dummies) and from blockMap


function clearConversationIdFromState(state, conversationIdInState, correlationId) {
  var blockMap = state.blockMap,
      openConversations = state.openConversations,
      dummyConversations = state.dummyConversations;
  return state.merge({
    blockMap: deleteConversationInBlockMap(blockMap, correlationId, conversationIdInState),
    dummyConversations: dummyConversations.delete(conversationIdInState),
    openConversations: openConversations.delete(conversationIdInState)
  });
} // Return new state with given conversation removed from blockMap,
// to be called from an action triggered by interaction in
// this app session (needs to be distinct from the realtime update)


function deleteConversationByUserAction(state, conversation) {
  var blockMap = state.blockMap,
      deleteConversationId = state.deleteConversationId,
      deleteConversationStatus = state.deleteConversationStatus,
      dummyConversations = state.dummyConversations;
  var correlationId = conversation.get('correlationId');
  var conversationId = conversation.get('id');
  var dummyId = (0, _conversationsHelpers.getDummyConversationId)(dummyConversations, conversationId);
  var conversationIdInState = dummyId || conversationId;

  if (blockMap.hasIn([correlationId, conversationIdInState])) {
    if (deleteConversationId === conversationIdInState && deleteConversationStatus === _constants.RequestStatus.SUCCEEDED) {
      // the remove success message has been shown, so we can remove it now
      return clearConversationIdFromState(state, conversationIdInState, correlationId);
    }
  }

  return state;
} // Return new state with given conversation removed in blockMap,
// to be called from a reaction to realtime update


function deleteConversationByRealtimeUpdate(state, conversation) {
  var blockMap = state.blockMap,
      deleteConversationId = state.deleteConversationId,
      dummyConversations = state.dummyConversations;
  var correlationId = conversation.get('correlationId');
  var conversationId = conversation.get('id');
  var dummyId = (0, _conversationsHelpers.getDummyConversationId)(dummyConversations, conversationId);
  var conversationIdInState = dummyId || conversationId;

  if (blockMap.hasIn([correlationId, conversationIdInState])) {
    if (deleteConversationId === conversationIdInState) {
      // this session is the one removing this conversation and showing UI messaging, so don't do anything
      return state;
    } // this wasn't a delete from this session, so we can simple remove it w/o showing anything


    return clearConversationIdFromState(state, conversationIdInState, correlationId);
  }

  return state;
} // Return new conversations block map with comment removed from it


function deleteCommentInBlockMap(state, comment) {
  var blockMap = state.blockMap,
      dummyConversations = state.dummyConversations;
  var conversationId = comment.get('conversationId');
  var dummyId = (0, _conversationsHelpers.getDummyConversationId)(dummyConversations, conversationId);
  var conversationIdInState = dummyId || conversationId;
  return blockMap.updateIn([comment.get('correlationId'), conversationIdInState, 'comments'], new _immutable.List(), function (current) {
    return current.filter(function (c) {
      return c.id !== comment.id;
    });
  });
} // Add conversation id to openConversations state if it's not already in there


function addToOpenConversations(openConversations, id) {
  if (openConversations.has(id)) {
    return openConversations;
  }

  return openConversations.add(id);
}

function updateStateForRealtimeAddedComment(state, commentData) {
  var updatedBlockMap = addCommentToBlockMap(state, _Comment.default.fromJS(commentData), true);
  return state.set('blockMap', updatedBlockMap);
} // Given blockMap, delete all empty dummy conversations from it


function removeEmptyDummyConversationsFromBlockMap(blockMap) {
  return blockMap.reduce(function (acc, block, key) {
    var filtered = block.filter(function (c) {
      return c.isEmptyDummy && c.comments.size > 0 || !c.isEmptyDummy;
    });

    if (filtered.size > 0) {
      return acc.set(key, filtered);
    }

    return acc.delete(key);
  }, blockMap);
} // Add a dummy conversation to the state


function updateStateWithDummyConversation(state, conversationData) {
  var dummyId = (0, _uniqueId.default)('dummy_conversation_');

  var conversation = _Conversation.default.fromJS(Object.assign({
    id: dummyId,
    isEmptyDummy: true
  }, conversationData));

  var updatedBlockMap = addConversationToBlockMap(state, conversation);
  return state.merge({
    blockMap: updatedBlockMap,
    selectedBlock: conversation.correlationId,
    showAddConversationButtonAtBlock: null,
    dummyConversations: state.dummyConversations.set(dummyId, null)
  });
} // Add new conversation id to dummy conversation translation map


function updateStateWithNewConversationId(state, dummyConversationId, conversation) {
  if (state.dummyConversations.has(dummyConversationId)) {
    return state.set('dummyConversations', state.dummyConversations.set(dummyConversationId, conversation.id));
  }

  return state;
}

function updateStateWithSelectedConversationBlock(state, selectedBlock) {
  var blockMap = state.blockMap;

  if (selectedBlock !== state.selectedBlock) {
    blockMap = removeEmptyDummyConversationsFromBlockMap(state.blockMap);
  }

  return state.merge({
    blockMap: blockMap,
    selectedBlock: selectedBlock
  });
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Conversations.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_FULL_COMPOSITION_SUCCEEDED:
      return _Conversations.default.fromJS(action.data.conversations);

    case _ActionTypes.default.SELECT_CONVERSATION_BLOCK:
      return updateStateWithSelectedConversationBlock(state, action.data);

    case _ActionTypes.default.SAVE_COMMENT_SUCCEEDED:
      // rather than querying the API, just take the comment from the server and merge it into the map
      return state.set('blockMap', addCommentToBlockMap(state, action.data));

    case _ActionTypes.default.CREATE_DUMMY_CONVERSATION:
      return updateStateWithDummyConversation(state, action.data);

    case _ActionTypes.default.CREATE_CONVERSATION_SUCCEEDED:
      return updateStateWithNewConversationId(state, action.data.dummyId, action.data.conversation);

    case _ActionTypes.default.DELETE_EMPTY_CONVERSATION:
      return state.set('blockMap', deleteConversationInBlockMap(state.blockMap, action.data.correlationId, action.data.idInState));

    case _ActionTypes.default.DELETE_CONVERSATION_PENDING:
      return state.merge({
        deleteConversationStatus: _constants.RequestStatus.PENDING,
        deleteConversationId: action.data
      });

    case _ActionTypes.default.DELETE_CONVERSATION_SUCCEEDED:
      return state.set('deleteConversationStatus', _constants.RequestStatus.SUCCEEDED);
    // The conversation has been deleted, but this action indicates that we want to remove it from the UI
    // We need the intermediary step because we want to show a "removed success" message in place of the conversation

    case _ActionTypes.default.DELETE_CONVERSATION_DONE:
      return deleteConversationByUserAction(state, action.data).set('deleteConversationId', null);

    case _ActionTypes.default.DELETE_CONVERSATION_FAILED:
      return state.merge({
        deleteConversationStatus: _constants.RequestStatus.FAILED,
        deleteConversationId: null
      });

    case _ActionTypes.default.DELETE_COMMENT_PENDING:
      return state.merge({
        deleteCommentStatus: _constants.RequestStatus.PENDING,
        deleteCommentId: action.data.id
      });

    case _ActionTypes.default.DELETE_COMMENT_SUCCEEDED:
      // rather than querying the API, just take the comment from the server and remove it from the map
      return state.merge({
        deleteCommentStatus: _constants.RequestStatus.SUCCEEDED,
        deleteCommentId: null,
        blockMap: deleteCommentInBlockMap(state, action.data)
      });

    case _ActionTypes.default.DELETE_COMMENT_FAILED:
      return state.set('deleteCommentStatus', _constants.RequestStatus.FAILED);
    // NOTES ON MAINTAINING BLOCKMAP STATE WITH REALTIME UPDATES:
    // 1. Realtime updates return raw objects, so we need to `fromJS` them to appropriate
    // data model types in order to use functions that operate on the conversation blockMap
    // 2. The strategy here for maintaining conversation blockMap state is to basically
    // perform the update (add new or delete existing) on the first response, which could
    // be either the actual request or from the Realtime update, and on the second response,
    // we simply do nothing because it's already been updated. This applies to conversations
    // and comments, but removing conversations is special because we need to show a removal
    // message - thus, if from the state, we know that this app session deleted a specific
    // conversation, in that case, we don't do anything when the associated Realtime update comes in

    case _ActionTypes.default.REALTIME_ADD_CONVERSATION:
      return state.set('blockMap', addConversationToBlockMap(state, _Conversation.default.fromJS(action.data)));

    case _ActionTypes.default.REALTIME_ADD_COMMENT:
      return updateStateForRealtimeAddedComment(state, action.data);

    case _ActionTypes.default.REALTIME_DELETE_CONVERSATION:
      return deleteConversationByRealtimeUpdate(state, _Conversation.default.fromJS(action.data));

    case _ActionTypes.default.REALTIME_DELETE_COMMENT:
      return state.set('blockMap', deleteCommentInBlockMap(state, _Comment.default.fromJS(action.data)));

    case _ActionTypes.default.SHOW_ADD_CONVERSATION_BUTTON:
      return state.set('showAddConversationButtonAtBlock', action.data);

    case _ActionTypes.default.HIDE_ADD_CONVERSATION_BUTTON:
      return state.set('showAddConversationButtonAtBlock', null);

    case _ActionTypes.default.CLOSE_CONVERSATIONS:
      return state.set('openConversations', state.openConversations.filter(function (id) {
        return !action.data.includes(id);
      }));

    case _ActionTypes.default.OPEN_CONVERSATION:
      return state.merge({
        blockMap: clearUpdatedFromConversationInBlockMap(state.blockMap, action.data),
        openConversations: addToOpenConversations(state.openConversations, action.data),
        showAddConversationButtonAtBlock: null
      });

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;